import './NavigationTop.css';
import logo from '../../assets/images/Logo.svg';
import { Link } from 'react-router-dom';
import {
  IcOutlineEmail,
  IcRoundClose,
  IcRoundMenu,
  JamFacebookSquare,
  MdiInstagram,
} from '../../assets/icons/icons';
import { useReducer } from 'react';

export default function NavigationTop() {
  const initialState = {
    mobileMenu: false,
  };

  const NavbarReducer = (state, action) => {
    switch (action.type) {
      case 'TOGGLE_MOBILE_MENU':
        return { ...state, mobileMenu: !state.mobileMenu };

      default:
        return state;
    }
  };

  const [state, dispatch] = useReducer(NavbarReducer, initialState);

  return (
    <nav className='navigation-top'>
      <div className='container-navbar'>
        <button
          className='opener-mobile-menu'
          onClick={() => dispatch({ type: 'TOGGLE_MOBILE_MENU' })}
        >
          <IcRoundMenu />
        </button>
        <a className='container-navigation-top-logo' href='/home#top'>
          <img
            className='navigation-top-logo'
            src={logo}
            alt="Prachurya's logo"
          />
        </a>

        <div className='container-links'>
          <ul className='list-nav-links'>
            <li>
              <a className='list-nav-links-item' href='/home#top'>
                Portfolio
              </a>
            </li>
            <li>
              <a className='list-nav-links-item' href='#section-brand'>
                Brands
              </a>
            </li>
            <li>
              <a className='list-nav-links-item' href='#section-about'>
                About Me
              </a>
            </li>
            <li>
              <a className='list-nav-links-item' href='#section-contact'>
                Contact
              </a>
            </li>
          </ul>

          <ul className='list-social-links'>
            <a
              className='list-social-links-item'
              target='_blank'
              href='https://www.instagram.com/prachurya_dash/'
              rel='noreferrer'
            >
              <MdiInstagram />
            </a>
            <a
              className='list-social-links-item'
              target='_blank'
              href='https://www.facebook.com/profile.php?id=100008046975410'
              rel='noreferrer'
            >
              <JamFacebookSquare />
            </a>
            <a className='list-social-links-item' href='#section-contact'>
              <IcOutlineEmail />
            </a>
          </ul>
        </div>
      </div>
      <div
        style={{ display: state.mobileMenu ? 'flex' : 'none' }}
        className='container-mobile-menu'
      >
        <button
          className='closer-mobile-menu'
          onClick={() => dispatch({ type: 'TOGGLE_MOBILE_MENU' })}
        >
          <IcRoundClose />
        </button>
        <Link className='container-mobile-menu-logo' to='/'>
          <img className='mobile-menu-logo' src={logo} alt="Prachurya's logo" />
        </Link>
        <ul className='mobile-menu-list-nav-links'>
          <li>
            <a
              className='mobile-menu-list-nav-links-item'
              href='/home#top'
              onClick={() => dispatch({ type: 'TOGGLE_MOBILE_MENU' })}
            >
              Portfolio
            </a>
          </li>
          <li>
            <a
              className='mobile-menu-list-nav-links-item'
              href='#section-brand'
              onClick={() => dispatch({ type: 'TOGGLE_MOBILE_MENU' })}
            >
              Brands
            </a>
          </li>
          <li>
            <a
              className='mobile-menu-list-nav-links-item'
              href='#section-about'
              onClick={() => dispatch({ type: 'TOGGLE_MOBILE_MENU' })}
            >
              About Me
            </a>
          </li>
          <li>
            <a
              className='mobile-menu-list-nav-links-item'
              href='#section-contact'
              onClick={() => dispatch({ type: 'TOGGLE_MOBILE_MENU' })}
            >
              Contact
            </a>
          </li>
        </ul>

        <ul className='mobile-menu-list-social-links'>
          <a
            className='mobile-menu-list-social-links-item'
            target='_blank'
            href='https://www.instagram.com/prachurya_dash/'
            rel='noreferrer'
            onClick={() => dispatch({ type: 'TOGGLE_MOBILE_MENU' })}
          >
            <MdiInstagram />
          </a>
          <a
            className='mobile-menu-list-social-links-item'
            target='_blank'
            href='https://www.facebook.com/profile.php?id=100008046975410'
            rel='noreferrer'
            onClick={() => dispatch({ type: 'TOGGLE_MOBILE_MENU' })}
          >
            <JamFacebookSquare />
          </a>
          <a
            className='mobile-menu-list-social-links-item'
            href='#section-contact'
            onClick={() => dispatch({ type: 'TOGGLE_MOBILE_MENU' })}
          >
            <IcOutlineEmail />
          </a>
        </ul>
      </div>
    </nav>
  );
}
